import React from 'react'
import SecurityIcon from '@material-ui/icons/Security'
import PeopleIcon from '@material-ui/icons/People'
import EcoIcon from '@material-ui/icons/Eco'
import ScheduleIcon from '@material-ui/icons/Schedule'
import { interpolate } from '../utils/proposalVariables'

const ICON_MAP = {
  shield: SecurityIcon,
  people: PeopleIcon,
  eco: EcoIcon,
  schedule: ScheduleIcon,
}

const AboutUs = ({ data, variables }) => {
  const highlights = data?.highlights || []
  const stats = data?.stats || []

  return (
    <div className="proposal-section proposal-about">
      <div className="proposal-section__headline">{interpolate(data?.headline || 'Why Choose Us', variables)}</div>
      <div className="proposal-section__accent-line" />

      {data?.body && (
        <div className="proposal-section__body proposal-about__body">
          {interpolate(data.body, variables)}
        </div>
      )}

      {/* Stats row */}
      {stats.length > 0 && (
        <div className="proposal-about__stats">
          {stats.map((stat, idx) => (
            <div className="proposal-about__stat" key={idx}>
              <div className="proposal-about__stat-value">{stat.value}</div>
              <div className="proposal-about__stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Highlight cards */}
      {highlights.length > 0 && (
        <div className="proposal-about__highlights">
          {highlights.map((item, idx) => {
            const IconComponent = ICON_MAP[item.icon] || EcoIcon
            return (
              <div className="proposal-about__highlight" key={idx}>
                <div className="proposal-about__highlight-icon">
                  <IconComponent style={{ fontSize: 20 }} />
                </div>
                <div>
                  <div className="proposal-about__highlight-title">{item.title}</div>
                  <div className="proposal-about__highlight-desc">{interpolate(item.description, variables)}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {/* Credentials / memberships */}
      {data?.credentials && (
        <div className="proposal-about__credentials">
          {interpolate(data.credentials, variables)}
        </div>
      )}

      {/* Testimonial quote (optional — only shows if quote text exists) */}
      {data?.quote && (
        <div className="proposal-about__quote-block">
          <div className="proposal-about__quote-mark">&ldquo;</div>
          <div className="proposal-about__quote-text">
            {interpolate(data.quote, variables)}
          </div>
          {(data?.quoteAttribution || data?.quoteTitle) && (
            <div className="proposal-about__quote-attribution">
              {data.quoteAttribution && (
                <span className="proposal-about__quote-name">{data.quoteAttribution}</span>
              )}
              {data.quoteTitle && (
                <span className="proposal-about__quote-role">{data.quoteTitle}</span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default AboutUs
